import {Component, OnInit, ViewChild} from '@angular/core';
import {UiService} from '../../../../services/ui.service';
import {TdoTableSelectionEvent} from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {MenuConfigurationModel} from '../../../../models/ui/menu/menu-configuration.model';
import {TdoTableV2Component} from '../../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {MenuMasterItemConfigurationModel} from '../../../../models/ui/menu/menu-master-item-configuration.model';
import {CdkDragDrop, CdkDragStart, copyArrayItem, moveItemInArray} from '@angular/cdk/drag-drop';
import {MenuItemConfigurationModel} from '../../../../models/ui/menu/menu-item-configuration.model';

@Component({
  selector: 'app-menu-configuration',
  templateUrl: './menu-configuration.component.html',
  styleUrls: ['./menu-configuration.component.scss']
})
export class MenuConfigurationComponent implements OnInit {
  @ViewChild('menuTable') menuTable: TdoTableV2Component;

  menus: MenuConfigurationModel[] = [];
  selectedMenu: MenuConfigurationModel;

  masterItems: MenuMasterItemConfigurationModel[] = [];
  selectedItems: MenuMasterItemConfigurationModel[] = [];

  isLoading = true;

  constructor(private uiService: UiService) {

  }

  ngOnInit(): void {
    this.uiService.getMenus().subscribe((menuRes) => {
      this.menus = menuRes;
      if (this.menus.length > 0) {
        this.selectedMenu = this.menus[0];

        this.uiService.getMenuMasterItems().subscribe((miRes) => {
          this.masterItems = miRes;
          this.isLoading = false;
          for (const it of this.selectedMenu.cfgMenuItems) {
            this.selectedItems.push(it.cfgMenuMasterItem);
          }
        });
      }
    });
  }

  onRowSelected(event: TdoTableSelectionEvent) {
    this.selectedMenu = event.model;
    this.selectedItems = [];
    for (const it of this.selectedMenu.cfgMenuItems) {
      this.selectedItems.push(it.cfgMenuMasterItem);
    }
  }

  onAddMenu() {
    const menu = new MenuConfigurationModel();
    this.menus.unshift(menu);
    this.menuTable.updateData(this.menus);
  }

  save() {
    this.uiService.saveMenu(this.selectedMenu).subscribe((res) => {
      this.selectedMenu = res;
    });
  }

  onMenuNameFinished(event: any) {
    this.selectedMenu.MenuName = event;
    this.save();
  }

  onMasterItemDragStarted(event: CdkDragStart, i: number) {
    // this.masterItems.splice(i, 0, event.source.data);
  }

  onMasterItemDragDropped(event: CdkDragDrop<MenuMasterItemConfigurationModel[]>) {
    const masterItem = event.previousContainer.data[0] as MenuMasterItemConfigurationModel;
    /*const item = new MenuItemConfigurationModel();
    item.MenuMasterItemId = masterItem.MenuMasterItemId;
    this.items[event.currentIndex] = item;*/
    if (event.previousContainer !== event.container && !this.selectedItems.includes(event.item.data)) {
      // this.items.push(event.item.data);

      copyArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
      // this.selectedItems = event.container.data;
      this.uiService.saveItems(this.selectedItems, this.selectedMenu).subscribe((res) => {

      });
    }
  }

  onItemDragDropped(event: CdkDragDrop<MenuMasterItemConfigurationModel[]>) {
    moveItemInArray(this.selectedItems, event.previousIndex, event.currentIndex);
    this.uiService.reorderItems(this.selectedItems, this.selectedMenu).subscribe((res) => {

    });
  }

  deleteItem(m: MenuMasterItemConfigurationModel) {
    this.uiService.deleteItem(m, this.selectedMenu).subscribe((res) => {
      const idx = this.selectedItems.findIndex(p => p.MenuMasterItemId === m.MenuMasterItemId);
      if (idx > -1) {
        this.selectedItems.splice(idx, 1);
      }
    });
  }

  checkIfInUse(mi: MenuMasterItemConfigurationModel) {
    return this.selectedItems.map(p => p.MenuMasterItemId).includes(mi.MenuMasterItemId);
  }
}
